export const testimonials = [
  {
    initials: 'MG',
    name: 'Mariela G.',
    location: 'Córdoba',
    role: 'Docente de Primer Grado',
    text: 'Organicé todo el año en una tarde. Llegué al lunes sin el agotamiento de siempre.',
  },
  {
    initials: 'SM',
    name: 'Sandra M.',
    location: 'Buenos Aires',
    role: 'Docente de Primer Grado',
    text: 'Los informes de diciembre los hice en dos horas. Nunca me había pasado eso.',
  },
  {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Rosario',
    role: 'Docente de Primer Grado',
    text: 'Dejé de buscar actividades sueltas. Ahora abro el tomo del mes y ya está.',
  },
]

export const moreTestimonials = [
  {
    initials: 'CR',
    name: 'Cecilia R.',
    age: 34,
    location: 'Mendoza',
    role: 'Docente de Primer Grado · 8 años',
    text: 'Las adaptaciones por nivel me salvaron. Ya no armo dos materiales por clase.',
  },
  {
    initials: 'SC',
    name: 'Sofía C.',
    age: 28,
    location: 'La Plata',
    role: 'Docente · 4 años',
    text: 'El 25 de Mayo fue el acto más organizado que tuve en diez años de docencia.',
  },
  {
    initials: 'PA',
    name: 'Pablo A.',
    age: 41,
    location: 'Neuquén',
    role: 'Docente + Coordinador · 12 años',
    text: 'El banco de frases para informes me ahorró dos semanas de diciembre.',
  },
]

export const tomos = [
  {
    id: 'T1',
    name: 'Diagnóstico y Adaptación',
    months: 'Marzo',
    content: 'Diagnóstico completo, adaptación y rutinas del grupo.',
    icon: '📘',
  },
  {
    id: 'T2',
    name: 'Alfabetización Inicial',
    months: 'Abril / Mayo',
    content:
      'Alfabetización inicial paso a paso. De las vocales a las primeras oraciones.',
    icon: '📗',
  },
  {
    id: 'T3',
    name: 'Matemática Primer Grado',
    months: 'Junio / Julio',
    content: 'Numeración, suma, resta y resolución de problemas.',
    icon: '📙',
  },
  {
    id: 'T4',
    name: 'Ciencias y Efemérides',
    months: 'Agosto / Septiembre',
    content: 'Ciencias Naturales, Sociales y efemérides patrias.',
    icon: '📕',
  },
  {
    id: 'T5',
    name: 'Lectura y Escritura',
    months: 'Octubre / Noviembre',
    content: 'Comprensión lectora, producción escrita y consolidación.',
    icon: '📓',
  },
  {
    id: 'T6',
    name: 'Cierre y Evaluación',
    months: 'Diciembre',
    content: 'Evaluaciones finales, banco de informes y diplomas.',
    icon: '📔',
  },
]

export const bonuses = [
  {
    id: '01',
    icon: '🗺️',
    name: 'Kit de Implementación Express',
    desc: 'El año listo en 10 minutos.',
    value: '$8.000',
  },
  {
    id: '02',
    icon: '✅',
    name: 'Checklist Anual de Clases Resueltas',
    desc: 'Cerrá cada viernes en 5 minutos.',
    value: '$10.000',
  },
  {
    id: '03',
    icon: '🎤',
    name: 'Banco de Consignas Claras',
    desc: '200+ consignas listas para Primer Grado.',
    value: '$9.000',
  },
  {
    id: '04',
    icon: '🔄',
    name: 'Pack de Rutinas Diarias',
    desc: 'El aula que funciona sola.',
    value: '$8.000',
  },
  {
    id: '05',
    icon: '📊',
    name: 'Planilla Maestra de Seguimiento',
    desc: 'Todo el grupo en una sola vista.',
    value: '$9.000',
  },
  {
    id: '06',
    icon: '🖨️',
    name: 'Kit de Presentación Prolija',
    desc: 'Carátulas y formatos listos para imprimir.',
    value: '$9.000',
  },
]

export const faqs = [
  {
    q: '¿Sirve para cualquier provincia?',
    a: 'Sí. Está basado en el Diseño Curricular Nacional y es aplicable en todo el país.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'En menos de 5 minutos recibís el enlace de descarga por email, listo para usar.',
  },
  {
    q: '¿Puedo empezar si el año ya empezó?',
    a: 'Sí. Cada tomo es independiente. Empezás desde el mes actual sin problema.',
  },
  {
    q: '¿La garantía es real?',
    a: 'Sí. Tenés 7 días. Escribinos a compradigitalyaa@gmail.com y te devolvemos todo, sin preguntas.',
  },
]

export const purchaseNotifications = [
  { name: 'Mariela G.', city: 'Córdoba', plan: 'Combo Completo Primer Grado' },
  {
    name: 'Sandra M.',
    city: 'Buenos Aires',
    plan: 'Combo + Aula Resuelta Pro',
  },
  { name: 'Laura P.', city: 'Rosario', plan: 'Combo Completo Primer Grado' },
  { name: 'Sofía C.', city: 'La Plata', plan: 'Combo + Aula Resuelta Pro' },
  { name: 'Pablo A.', city: 'Neuquén', plan: 'Combo Completo Primer Grado' },
  { name: 'Cecilia R.', city: 'Mendoza', plan: 'Combo + Aula Resuelta Pro' },
  { name: 'Verónica M.', city: 'Salta', plan: 'Combo Completo Primer Grado' },
  { name: 'Diego F.', city: 'Tucumán', plan: 'Combo + Aula Resuelta Pro' },
  {
    name: 'Andrea L.',
    city: 'Mar del Plata',
    plan: 'Combo Completo Primer Grado',
  },
  {
    name: 'Martín S.',
    city: 'Bahía Blanca',
    plan: 'Combo + Aula Resuelta Pro',
  },
]
